<template>
    <div class="md:container mx-auto relative ot-notice-component">
        <h1 v-if="blok.Title">{{ blok.Title }}</h1>
        <div :id="noticeContainerId" class="otnotice"></div>
    </div>
</template>

<script setup lang="ts">
import type { IOtNoticeSection } from '@nuxt-monorepo/ui/types/components/OtNotice';

interface Props {
    blok: IOtNoticeSection;
}

const props = defineProps<Props>();

const isStorageVariant = computed(() => props.blok.variant === 'storageContainer');

const scriptSettings = computed(() =>
    isStorageVariant.value ? `settings="${props.blok.settingsId}"` : `settings: ${props.blok.settingsId}`
);

const noticeUrl = computed(() => {
    const baseUrl = 'https://privacyportal-uk-cdn.onetrust.com';
    const path = isStorageVariant.value
        ? `/storage-container/${props.blok.privacyToken}/privacy-notices/${props.blok.privacyId}/published/privacynotice.json`
        : `/${props.blok.privacyToken}/privacy-notices/${props.blok.privacyId}.json`;

    return `${baseUrl}${path}`;
});

const noticeContainerId = computed(() => `otnotice-${props.blok.privacyId}`);

useHead({
    script: [
        {
            src: 'https://privacyportal-uk-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js',
            innerHTML: scriptSettings.value,
            id: 'otprivacy-notice-script',
        },
        {
            innerHTML: `setTimeout(() => {
    OneTrust.NoticeApi.Initialized.then(function() {
        OneTrust.NoticeApi.LoadNotices(["${noticeUrl.value}"]);
    });
}, 100);`,
        },
    ],
});
</script>

<style scoped lang="postcss">
h1 {
    @apply ml-16 mr-0 mt-4 mb-8;
}

.otnotice :deep(.otnotice-menu) {
    position: absolute !important;
}
</style>
